import React from 'react';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box
} from '@mui/material';

interface RenderDataTableProps {
  data: Array<{
    [key: string]: unknown;
  }>;
  title?: string;
  noDataFoundMessage?: string;
}

export const RenderDataTable: React.FC<RenderDataTableProps> = ({ data, title, noDataFoundMessage }) => {
  // Handle empty data
  if (!data || data.length === 0) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography variant="body1" color="text.secondary">
          {noDataFoundMessage || 'No data found.'}
        </Typography>
      </Box>
    );
  }

  // Extract column headers from the first data item
  const headers = Object.keys(data[0]);

  return (
    <TableContainer component={Paper} sx={{ mb: 4 }}>
      <Table size="small" aria-label="data table">
        <TableHead>
          <TableRow sx={{ backgroundColor: 'primary.light' }}>
            {headers.map((header) => (
              <TableCell key={header} sx={{ fontWeight: 'bold' }}>
                {header}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, rowIndex) => (
            <TableRow
              key={rowIndex}
              sx={{ '&:nth-of-type(odd)': { backgroundColor: 'action.hover' } }}
            >
              {headers.map((header) => (
                <TableCell key={`${rowIndex}-${header}`}>
                  {row[header] !== null && row[header] !== undefined
                    ? String(row[header])
                    : '—'}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RenderDataTable;
